/**
 * Created by alex.y on 7/20/2017.
 */
export enum CurrencyEnum{
    FXAUDCAD = "Australian dollar",
    FXBRLCAD = "Brazilian real",
    FXCNYCAD = "Chinese renminbi",
    FXEURCAD = "European euro",
    FXHKDCAD = "Hong Kong dollar",
    FXINRCAD = "Indian rupee",
    FXIDRCAD = "Indonesian rupiah",
    FXJPYCAD = "Japanese yen",
    FXMYRCAD = "Malaysian ringgit",
    FXMXNCAD = "Mexican peso",
    FXNZDCAD = "New Zealand dollar",
    FXNOKCAD = "Norwegian krone",
    FXPENCAD = "Peruvian new sol",
    FXRUBCAD = "Russian ruble",
    FXSARCAD = "Saudi riyal",
    FXSGDCAD = "Singapore dollar",
    FXZARCAD = "South African",
    FXKRWCAD = "South Korean",
    FXSEKCAD = "Swedish krona",
    FXCHFCAD = "Swiss franc",
    FXTWDCAD = "Taiwanese dollar",
    FXTHBCAD = "Thai baht",
    FXTRYCAD = "Turkish lira",
    FXGBPCAD = "UK pound",
    FXUSDCAD = "US dollar",
    FXVNDCAD = "Vietnamese dong",
}


// WEBPACK FOOTER //
// ./app/objects/currencyExchange/currencyEnum.ts